module.exports = __webpack_public_path__ + "static/media/ranking-arrow.329d8ed6.svg";